// extracted by mini-css-extract-plugin
export default {"status":"ServerError_status__7T44X","title":"ServerError_title__1WBvx","message":"ServerError_message__SIajM"};